import { VerificationEmail } from '../../components/signup';

const VerificationEmailPage = () => {
  const email = localStorage.getItem('email');

  return <VerificationEmail email={email} />;
};

export default VerificationEmailPage;
